/* eslint-disable */
const shareNavbar = document.getElementById( 'socialShare' );
let shareSticky   = 0;

if ( shareNavbar ) {
	shareSticky = shareNavbar.offsetTop;
}

window.onscroll = function() {
	myFunction();
	if ( shareNavbar ) {
		socialStickyScroll();
	}
};

const navbar = document.getElementById( "site-navigation" );
const sticky = navbar.offsetHeight;

function myFunction() {
	if ( window.pageYOffset >= sticky - 35 ) {
		navbar.classList.add( "sticky" );
	} else {
		navbar.classList.remove( "sticky" );
	}
}

function socialStickyScroll() {
	if ( window.pageYOffset >= shareSticky - 50 ) {
		shareNavbar.classList.add( 'sticky' );
	} else {
		shareNavbar.classList.remove( 'sticky' );
	}
}
